import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { logout, redirectToCopilot } from "../../utils/commonServices";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAppleSignState } from "../../redux/appleSignSlice";

const AuthRedirect = (props) => {
  const [searchParams] = useSearchParams();
  const requestType = searchParams.get('request');
  const commonReducer = useSelector((state) => state.root.commonReducer);
  const appleSignReducer = useSelector((state) => state.appleSignReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [banner, setBanner] = useState("Please wait while we redirect for authentication...")

  useEffect(() => {

    if (requestType == 'logout') {
      if (!!window.localStorage.getItem('token')) {
        // dispatch(updateAppleSignState({is_redirected_from_butterfly: true}))
        logout(dispatch)
      }
      navigate(!window.localStorage.getItem("is_okta_user") && !window.localStorage.getItem("is_entra_user") ? '/signin' : '/auth/callback')

    }

    if (requestType == 'login') {

      if (!!window.localStorage.getItem('token')) {
        // KAN-14: the code lives 60 seconds, so it is requested and followed
        // immediately rather than after a cosmetic delay. The old `?k=` link
        // carried the session JWT itself, encrypted with a bundled key.
        redirectToCopilot(dispatch, () => setBanner("We could not complete the sign-in handoff. Please try again."))

      } else {
        if (window.localStorage.getItem('logout_all') !== 'true') {
          dispatch(updateAppleSignState({ is_redirected_from_butterfly: true }))

        }
        navigate(!window.localStorage.getItem("is_okta_user") && !window.localStorage.getItem("is_entra_user") ? '/signin' : '/auth/callback')
      }

    }
    if (requestType == 'timeout') {
       setBanner("Your request is timed out! This may be due to slower internet.")
    }

  }, [requestType, window.localStorage.getItem('token'), commonReducer.logout_all])

  return <Box sx={{ display: 'flex', color: '#000000', backgroundColor: '#ffffff', width: '100%', height: '100vh', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
    <Typography fontSize={34} p={8}>{banner}</Typography>
  </Box>


}

export default AuthRedirect